import React, {Component} from 'react'
import ReactPaginate from "react-paginate"
import PropTypes from "prop-types"
import classNames from 'classnames'


class NextPagination extends Component {
    _handlePageClick = page => {
        if (!page || typeof page !== 'object') return false

        const {selected} = page
        const vPage = selected > 0 ? parseInt(selected, 10) : 0

        this.props.onChange(vPage + 1)
    }

    render() {
        const {page, limit, loading, total} = this.props
        const pages = Math.ceil(total / limit)

        return (
            <div className="NextPagination">
                <ReactPaginate
                    forcePage={page - 1}
                    previousLabel={<i className="fa fa-arrow-left" />}
                    previousClassName='page-item previous'
                    previousLinkClassName='page-link'
                    nextLabel={<i className="fa fa-arrow-right" />}
                    nextClassName='page-item next'
                    nextLinkClassName='page-link'
                    breakLabel='...'
                    breakClassName='break-me'
                    pageCount={pages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this._handlePageClick}
                    containerClassName={classNames('pagination', {loading})}
                    pageClassName='page-item'
                    pageLinkClassName='page-link'
                    activeClassName='active'/>
            </div>
        )
    }
}

NextPagination.defaultProps = {
    loading: false,
}


NextPagination.propTypes = {
    page: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
}

export default NextPagination
